import { t } from 'i18next'
import { z } from 'zod'

import { PersonaType } from '@/modules/shared/schemas/PersonaInfoSummary'

import { TicketPriority } from './AreaPriorities'
import { ResponsibleInfo } from './Ticket'

export const SubArea = z.object({
  id: z.string(),
  name: z.string(),
  isGeneric: z.boolean(),
  priority: TicketPriority,
  personaTypes: z.array(PersonaType),
  attendants: z.array(
    z.object({
      id: z.string(),
      persona: ResponsibleInfo
    })
  )
})

export const SubAreaDTO = z.object({
  name: z.string().min(1, t('general.form.required')),
  personaTypes: z.array(PersonaType).min(1, t('general.form.required')),
  priority: TicketPriority,
  attendants: z
    .array(z.object({ personaId: z.string() }))
    .min(1, t('general.form.required'))
})

export type SubArea = z.infer<typeof SubArea>
export type SubAreaDTO = z.infer<typeof SubAreaDTO>
